import PrivateSalesIndex from './components/private-sales-index/PrivateSalesIndex.vue';
import PrivateSaleShow from './components/private-sale-show/PrivateSaleShow.vue';

export default function registerAdminVueComponents(app) {
    app.component('private-sales-index', PrivateSalesIndex);
    app.component('private-sale-show', PrivateSaleShow);
}
